import { SplashScreen } from "../../classes/SplashScreen"

let splash = SplashScreen.getInstance()
splash.init()
